import React from "react";
import PropTypes from "prop-types";

import { Helmet } from "react-helmet-async";

import { META_TITLE_DESC, META_DESCRIPTION } from "src/consts/meta";
import { useCanonicalUrl } from "src/hooks/meta";
import LogoBigFlip from "src/assets/images/common/logo-big-flip.png";

const propTypes = {
  /**
   * Set head title
   */
  title: PropTypes.string,

  /**
   * Set meta description
   */
  description: PropTypes.string,

  /**
   * If want to use custom title on title prop
   */
  isCustomTitle: PropTypes.bool
};

const defaultProps = {
  title: "",
  description: META_DESCRIPTION,
  isCustomTitle: false,
  customTag: <meta name="viewport" content="width=device-width, initial-scale=1" />
};

function CustomHead(props) {
  const { title, description, isCustomTitle, image, customTag } = props;

  let metaTitle = "";
  if (isCustomTitle) metaTitle = title;
  else metaTitle = title ? [title, "Flip for Business"].filter(Boolean).join(" - ") : META_TITLE_DESC;

  const canonicalUrl = useCanonicalUrl();

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <link rel="canonical" href={canonicalUrl} />

      {/* <!-- Primary Meta Tags --> */}
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={description} />

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || LogoBigFlip} />

      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image || LogoBigFlip} />

      {customTag}
    </Helmet>
  );
}

CustomHead.propTypes = propTypes;
CustomHead.defaultProps = defaultProps;

export default CustomHead;
